import Button from "@components/ui/Button";

const FILTERS = [
  { key: "all", label: "All" },
  { key: "matched", label: "Matched" },
  { key: "unmatched", label: "Unmatched" },
];

export default function CallMatchingHeader({
  clinics,
  selectedClinicId,
  onSelectClinic,
  filter,
  onFilterChange,
  onRefresh,
  loading,
}) {
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex items-center gap-3">
        <h1 className="text-lg sm:text-xl font-semibold">Call Matching</h1>
      </div>

      <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
        {/* Clinic selector */}
        <select
          value={selectedClinicId}
          onChange={(e) => onSelectClinic(e.target.value)}
          className="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        >
          <option value="">Select clinic...</option>
          {clinics.map((c) => (
            <option key={c.id} value={c.id}>
              {c.clinic_name}
            </option>
          ))}
        </select>

        {/* Filter buttons */}
        <div className="flex rounded-lg border border-gray-300 overflow-hidden">
          {FILTERS.map((f) => (
            <button
              key={f.key}
              onClick={() => onFilterChange(f.key)}
              className={`px-3 py-1.5 text-xs font-medium transition-colors ${
                filter === f.key
                  ? "bg-gray-900 text-white"
                  : "bg-white text-gray-600 hover:bg-gray-50"
              }`}
            >
              {f.label}
            </button>
          ))}
        </div>

        {/* Refresh */}
        <Button
          color="light"
          size="sm"
          onClick={onRefresh}
          disabled={loading || !selectedClinicId}
        >
          Refresh
        </Button>
      </div>
    </div>
  );
}
